module.exports = __webpack_public_path__ + "img/logo.6ad8136f.png";